import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-spice-dark text-spice-cream pt-12 pb-6">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <img src="/images/logo.png" alt="Rupved Agro" className="h-10 w-auto" />
            </div>
            <p className="mb-2">📞 +91 98765 43210</p>
            <p className="mb-2">📞 +91 87654 32109</p>
            <p className="mb-2">📍 123, Spice Market, Indore, Madhya Pradesh - 452001, India</p>
          </div>
          <div>
            <h3 className="text-xl font-playfair font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="hover:text-primary transition-colors">Home</Link></li>
              <li><Link to="/about" className="hover:text-primary transition-colors">About Us</Link></li>
              <li><Link to="/products" className="hover:text-primary transition-colors">Products</Link></li>
              <li><Link to="/contact" className="hover:text-primary transition-colors">Contact</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="text-xl font-playfair font-semibold mb-4">Policies</h3>
            <ul className="space-y-2">
              <li><Link to="/privacy" className="hover:text-primary transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-primary transition-colors">Terms & Conditions</Link></li>
              <li><Link to="/return" className="hover:text-primary transition-colors">Cancellation & Return</Link></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-spice-brown mt-8 pt-6 text-center text-sm">
          <p>&copy; 2024 Rupved Agro. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;